"use strict";

angular.module("customer")
.service("VendorInventoryExternalSyncService", function($http, appConfig) {
    this.syncProductInventory = function(vendor_id, product_ids) {
        return $http({
            method: "POST",
            ignoreLoadingBar: true,
            url: appConfig.API_SERVER + "/catalog/customer/products/inventory/sync/",
            data: {
                vendor_id: vendor_id,
                product_ids: product_ids
            }
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/vendor-inventory-external-sync/vendor-inventory-external-sync.service.js
// module id = 874
// module chunks = 0